import { TableViewStore, BaseListViewStore, BaasicDropdownStore } from "core/stores";
import { TrackingCaseService, CaseStatusService } from "application/tracking-case/services";
import { LocalPatientService } from "application/patient/services";
import { FacilityService } from 'application/facility/services';
import { ItemCategoryService} from 'application/product/services';
import { toDate } from 'core/utils';
import { action } from "mobx";

class TrackingCaseListViewStore extends BaseListViewStore {
	constructor(rootStore) {
        const service = new TrackingCaseService(rootStore.application.baasic.apiClient);
        const localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
			autoInit: true,
			routes: {
				edit: id => {
					this.rootStore.routerStore.goTo("master.app.main.tracking-case.edit", { id: id });
				},
				create: () => {
					this.rootStore.routerStore.goTo("master.app.main.tracking-case.create");
				},
				preview: id =>{
                    this.rootStore.routerStore.goTo(
                        'master.app.main.tracking-case.preview',
                        { id: id }
                    );
                },
				documents: id => {
					// debugger
					this.rootStore.routerStore.goTo("master.app.main.tracking-case.documents", { id: id });
				},
				notes:  id => {
					// debugger
					this.rootStore.routerStore.goTo("master.app.main.tracking-case.notes.list", {trackingCaseId: id})}
			},
			actions: () => {
				return {
					find: async params => {
						const response = await service.find({...params, embed:"Facility,ItemCategory,Patient,TrackingCaseProducts,CaseStatus"});
						response.data.item = response.data.item.map(trackCase => {
							let trackingCaseProducts = trackCase.trackingCaseProducts &&
								trackCase.trackingCaseProducts.map(i=>i.product.itemId).join(", ");
							return {
								...trackCase, 
								trackingCaseProducts: trackingCaseProducts,
								validFrom: toDate(trackCase.validFrom),
								validTo: trackCase.validTo ? toDate(trackCase.validTo) : null,
								patient: trackCase.patient && `${trackCase.patient.lastName}, ${trackCase.patient.firstName}`
							}
						});
						return response.data;
					},
					copy: async resource => {
                        const response = await service.copy(resource);
                        return response.data;
                    },
					delete: service.delete,
				};
			},
		});

        this.caseStatusService = new CaseStatusService(rootStore.application.baasic.apiClient);

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await facilityService.find({ searchQuery: term, rpp: 10, inActive: false });
                return response.data.item;
            }
        });

        this.itemCategoryStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
				const response = await itemCategoryService.find({ 
					searchQuery: term, 
					rpp: 100
				});
				return response.data.item;
			},
		});

        this.caseStatusStore = new BaasicDropdownStore({
			filterable: false
		}, {
			fetchFunc: async(term) => {
				const response = await this.caseStatusService.lookup({ searchQuery: term });
				return response.item;
			}
		});

        this.localPatientStore = new BaasicDropdownStore({
			filterable: true,
			textField:"name",
		}, {
			fetchFunc: async(term) => {
				const response = await localPatientService.find({ 
					sort:"lastName|asc",
					searchQuery: term, 
					rpp: 100
					});
				
				return response.data.item.map(item=>{
					return {
						name: `${item.lastName}, ${item.firstName}`,
						...item
					}	
				});
			},
			initValueFunc: async () => {
				let response = await localPatientService.get(this.rootStore.routerStore.routerState.queryParams.patientId);
				const patientItem = {name: `${response.data.lastName}, ${response.data.firstName}`, ...response.data};
				this.localPatientStore.originalItems.push(patientItem)
				return patientItem;
			}
		});

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: "docCode",
						title: "TRACKING_CASE.LIST.COLUMNS.DOC_CODE"
					},
					{
						key: "patient",
						title: "TRACKING_CASE.LIST.COLUMNS.PATIENT"
					},
					{
						key: "facility.name",
						title: "TRACKING_CASE.LIST.COLUMNS.FACILITY",
						width: 320
					},
					{
						key: "itemCategory.name",
						title: "TRACKING_CASE.LIST.COLUMNS.ITEM_CATEGORY"
					},
					// {
					// 	key: "reference",
					// 	title: "TRACKING_CASE.LIST.COLUMNS.REFERENCE"
					// },
					{
						key: "trackingCaseProducts",
						title: "TRACKING_CASE.LIST.COLUMNS.TRACKING_CASE_PRODUCTS",
						sortable:false
					},
					// {
					// 	key: "payorSource",
					// 	title: "TRACKING_CASE.LIST.COLUMNS.PAYORE_SOURCE"
					// },
					{
						key: "validFrom",
						title: "TRACKING_CASE.LIST.COLUMNS.VALID_FROM",
						width: 110
					},
					{
						key: "validTo",
						title: "TRACKING_CASE.LIST.COLUMNS.VALID_TO",
						width: 110
					},
					{
						key: "caseStatus.name",
						title: "TRACKING_CASE.LIST.COLUMNS.CASE_STATUS",
						width: 100
					}
				],
				actions: {
					onCopy: item => this.copyTrackingCase(item),
					onPreview: (item) => this.routes.preview(item.id),
					onDocuments: item => this.routes.documents(item.id),
					onEdit: item => this.routes.edit(item.id),
					onDelete: (item) => this.deleteResource(item),
					onNotes: item => {
						this.routes.notes(item.id)},
					actionsWidth: 165
				},
			})
		);

        this.queryUtility.onResetFilter = () => {
			this.facilityStore.setValue(null);
			this.facilityStore.filterTerm = "";

			this.localPatientStore.setValue(null);
			this.localPatientStore.filterTerm = "";

            this.itemCategoryStore.setValue(null);
			this.itemCategoryStore.filterTerm = "";

            this.caseStatusStore.setValue(null);
        }
    }

	@action.bound
	async copyTrackingCase(item) {
        const { modalStore, notificationStore } = this.rootStore;

		modalStore.showConfirm(
            'LIST_LAYOUT.CONFIRM_COPY',
            async () => {
				try {

					await this.actions.copy({ id: item.id });

					notificationStore.success("TRACKING_CASE.COPY.SUCCESS");
				} catch(err){
					notificationStore.error("TRACKING_CASE.COPY.ERROR", err);
				}

				await this.queryUtility.fetch();
			},
			() => {
                modalStore.confirmParams.close();
            }
		);
	}

	@action.bound
	deleteResource(resource) {
        if (!this.actions.find || !this.actions.delete) return;
        
        const { modalStore, notificationStore } = this.rootStore;

        modalStore.showConfirm(
            'TRACKING_CASE.DELETE.CONFIRM_DELETE',
            async () => {
                try {
                    await this.actions.delete(resource);
                    notificationStore.success('TRACKING_CASE.DELETE.SUCCESS');
                    await this.queryUtility.fetch();
                } catch (err) {
                    notificationStore.error('LIST_LAYOUT.ERROR_DELETE', err);
                }
            }
        );
    }
}

export default TrackingCaseListViewStore;